import A from 'const/actionTypes'
import actions from 'actions'

export default {
  clearCounterStrikeGlobalOffensiveSettings: () => {
    return (dispatch, getState) => {
      dispatch({ type: A.CLEAR_COUNTERSTRIKE_GLOBAL_OFFENSIVE_SETTINGS, })
    }
  },
  selectCounterStrikeGlobalOffensiveWeapon: (weaponId, weaponPack) => {
    return (dispatch, getState) => {
      const currentGamerPurchaseProfile = getState().currentGamerPurchaseProfile
      const purchasedPacks = currentGamerPurchaseProfile.counterStrikeGlobalOffensivePacks

      if (purchasedPacks && purchasedPacks[weaponPack]) {
        dispatch({
          type: A.SET_COUNTER_STRIKE_GLOBAL_OFFENSIVE_WEAPON,
          selectedWeapon: weaponId,
        })
      } else {
        dispatch(actions.alertGamer({ message: 'Invalid Selection.', }))
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/app/actions/counterStrikeGlobalOffensive.js